import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LipomaPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Lipoma</h1>
        <section className="mb-8">
          <p>A lipoma is a benign fatty tumor that develops under the skin. Our natural therapies focus on reducing the size of lipomas, preventing new growths, and improving overall health through gentle, non-invasive methods.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Genetic factors</li>
            <li>Metabolic disorders</li>
            <li>Poor diet</li>
            <li>Lifestyle factors</li>
            <li>Hormonal imbalances</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Soft, movable lumps under skin</li>
            <li>Painless growths</li>
            <li>Multiple lipomas</li>
            <li>Gradual increase in size</li>
            <li>Discomfort in some cases</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use fat-reducing herbs, metabolic regulators, and lifestyle modifications to naturally treat lipomas. Our approach focuses on reducing the size of existing lipomas, preventing new growths, and improving overall health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-surgical treatment</li>
            <li>Reduces lipoma size</li>
            <li>Prevents new growths</li>
            <li>Improves overall health</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a healthy diet</li>
            <li>Regular exercise</li>
            <li>Stress management</li>
            <li>Regular health check-ups</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment remove lipomas?</strong>
            <p>A: Yes, our natural approach can help reduce the size of lipomas and prevent new growths.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment painful?</strong>
            <p>A: Our treatments are gentle and non-invasive, focusing on natural healing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long does treatment take?</strong>
            <p>A: Treatment duration varies, but many patients see improvement within a few months.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from lipomas—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default LipomaPage; 